<template>
  <q-separator class="q-ma-xs" />
  <q-expansion-item
    :class="
      $q.dark.mode == false ? 'bg-teal-1 text-bold bg-gradient' : 'bg-grey-9 '
    "
  >
    <template v-slot:header>
      <q-item-section> Pro Scanning & Backtesting </q-item-section>
    </template>
    <!-- Custom Signal Pro Results -->
    <q-expansion-item
      v-if="savedCustomSignalV2ResultData.length > 0"
      :class="$q.dark.mode == false ? 'bg-grey-1 text-bold' : 'bg-grey-9 '"
    >
      <template v-slot:header>
        <q-item-section class="ellipsis">
          Custom Signal Pro Results
        </q-item-section>
      </template>
      <q-item
        v-for="link in savedCustomSignalV2ResultData"
        :key="link.id"
        v-ripple
        clickable
        :class="
          $q.dark.mode == false
            ? ' menu-item  text-weight-regular text-bold'
            : ' menu-item  text-weight-regular bg-grey-9 '
        "
        @click="openCustomSignalProV2(link)"
      >
        <q-item-section avatar>
          <q-icon color="grey" :name="'save'" />
        </q-item-section>
        <q-item-section>
          <q-item-label> {{ link.name }} </q-item-label>
        </q-item-section>
      </q-item>
    </q-expansion-item>
    <q-separator
      class="q-ma-xs"
      v-if="savedCustomSignalV2ResultData.length > 0"
    />
    <q-item
      v-for="link in ProScanningZone"
      :key="link.text"
      v-ripple
      clickable
      :class="
        $q.dark.mode == false
          ? ' menu-item bg-white text-weight-regular bg-white text-bold'
          : ' menu-item bg-white text-weight-regular bg-grey-9 '
      "
      :to="{ name: link.name }"
    >
      <q-item-section avatar>
        <q-icon color="grey" :name="link.icon" />
      </q-item-section>
      <q-item-section>
        <q-item-label>
          {{ link.text }}

          <template
            v-if="
              link.name === 'CustomSignalPro' || link.name === 'BackTestEngine'
            "
          >
            <!-- <sup
                class="text-bold text-caption live q-pl-x"
                style="color: #1976d2"
              >
                New
              </sup> -->
          </template>
          <template v-if="link.name === 'CustomSignalProV2Save'">
            <sup
              class="text-bold text-caption live q-pl-x"
              style="color: #1976d2"
            >
              Beta
            </sup>
          </template>
          <template v-if="link.name === 'CustomSignalProV2'"> </template>
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-expansion-item>
</template>
<script setup>
import { useRouter } from "vue-router";
const $router = useRouter();
const props = defineProps({
  ProScanningZone: Array,
  savedCustomSignalV2ResultData: Array,
});

const openCustomSignalProV2 = (link) => {
  $router.push({
    name: "CustomSignalProV2Results",
    query: { id: link.id },
  });
};
</script>
